import atlasian from "../../img/atlasian.png"
import sparkle from "../../img/Sparkle.png"
import gadget_galaxy from "../../img/gadget_galaxy.png"

export const project = [
  {
    img: atlasian,
    title: "Atlassian-Clone",
    desc: "Atlasion's project website, driven by ReactJS and Typescript, enables seamless exploration of key products like Jira, Confluence, and Bitbucket with a user-friendly interface. It offers comprehensive insights, reflecting our dedication to intuitive software navigation.",
    tech: "React, TypeScript,Chakara-Ui, CSS, JAVASCRIPT",
    git: "https://github.com/tashwini-p/atlasion",
    deploy: "https://atlasian-clone.netlify.app/"
  },
  {
    img: sparkle,
    title: "Tanishq Clone",
    desc: "Sparkle, an enchanting online jewelry platform inspired by Tanishq's elegance, offers a simulated experience akin to real shopping. With authentication features, users can explore curated collections and purchase exquisite jewelry symbolizing life's special moments.",
    tech: "Html,CSS,JAVASCRIPT",
    git: "https://github.com/Anujkumar960/Sparkle",
    deploy: "https://sparkle-clone.netlify.app/"
  },

  {
    img: gadget_galaxy,
    title: "Reliance-Digital Clone",
    desc: "Gadget Galaxy, an electronic E-commerce platform, offers a diverse selection of gadgets. Crafted by a team of 5, the project prioritizes seamless user experiences. Built with HTML, CSS, and Bootstrap, it delivers a streamlined shopping interface for the latest electronics.",
    tech: "Html,Bootstrap, CSS",
    git: "https://github.com/Anujkumar960/Gadget-Galaxy",
    deploy: "https://gadget-galaxy-project.netlify.app/"
  }
  
];
